export const FETCH_STORES = "FETCH_STORES";
export const FETCH_MAIN_STORE = "FETCH_MAIN_STORE";
export const STORES_AND_BRAND_RESULT = "STORES_AND_BRAND_RESULT";

/***User***/
export const LOGIN_USER = "LOGIN_USER";
export const ACTIVE_CODE = "ACTIVE_CODE";
export const RESEND_CODE = "RESEND_CODE";
export const LOG_OUT = "LOG_OUT";
export const FETCH_MY_DISCOUNTS = "FETCH_MY_DISCOUNTS";

/***Modal-Invitation***/
export const CHANGE_STATUS_SHOW_MODAL_INVITATION = "CHANGE_STATUS_SHOW_MODAL_INVITATION";
export const CHANGE_LOADER_MODAL_INVITATION = "CHANGE_LOADER_MODAL_INVITATION";

/***Modal-My-Discount***/
export const CHANGE_STATUS_SHOW_MODAL_MY_DISCOUNTS = "CHANGE_STATUS_SHOW_MODAL_MY_DISCOUNTS";
export const PUT_SET_MY_DISCOUNTS = "PUT_SET_MY_DISCOUNTS";
export const CHANGE_LOADER_MODAL_MY_DISCOUNT = "CHANGE_LOADER_MODAL_MY_DISCOUNT";

export const FETCH_SHOW_MY_DISCOUNT = "FETCH_SHOW_MY_DISCOUNT";

export const PUT_SET_DISCOUNTS_CODES = "PUT_SET_DISCOUNTS_CODES";

export const FETCH_INVITATION_LINK = "FETCH_INVITATION_LINK";

export const PUT_INVITATION_LINK = "PUT_INVITATION_LINK";

export const CHANGE_STATUS_SHOW_MODAL_MY_FOOD_PACKS = "CHANGE_STATUS_SHOW_MODAL_MY_FOOD_PACKS";
export const CHANGE_LOADER_MODAL_MY_FOOD_PACKS = "CHANGE_LOADER_MODAL_MY_FOOD_PACKS";
export const PUT_SET_MY_FOOD_PACKS = "PUT_SET_MY_FOOD_PACKS";